import { RENDER } from '../metadata/types.js';
import { resolveProps } from './resolve-props.js';
function shouldRenderElement(props, options = {}) {
    const { breakpoint, locale } = options;
    const resolvedProps = resolveProps(props, breakpoint, locale);
    const renderProp = resolvedProps[RENDER];
    return renderProp !== false;
}
export { shouldRenderElement, };
//# sourceMappingURL=should-render-element.js.map